export default IconSlashes => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-slashes" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M14 5l-10 14" />
  <path d="M20 5l-10 14" />
</svg>`;